// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kCuc","rootNoMargin":"styles_rootNoMargin__2tzNY"};